import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { hasRole } from "@data/utility/ability"
import { plr } from "@data/utility/Utils"
import { useNavigation } from "@react-navigation/native"
import React, { useContext } from "react"
import { View } from "react-native"
import { connect } from "react-redux"
import mealsImage from "../../../../assets/icons/generic/lunch-bag.png"
import treesImage from "../../../../assets/icons/generic/tree.png"
import xpSquare from "../../../../assets/icons/generic/xp_square.png"
import ranking from "../../../../assets/icons/menus/ranking.png"
import { theme } from "../../theme/theme"
import { DimensionsContext } from "../../utils/mobileUtils"
import { StatisticsItem } from "./StatisticsItem"

function StatisticsList(props) {
    const { student, style, navigation } = props

    const nav = navigation ?? useNavigation()

    const countTreesPurchases = student?.shop_purchases?.filter(
        (p) => p?.shop_product_id === 1
    )?.length
    const countMealsPurchases = student?.shop_purchases?.filter(
        (p) => p?.shop_product_id === 2
    )?.length

    const dimensions = useContext(DimensionsContext)

    return (
        <View
            style={{
                flexWrap: "wrap",
                flexDirection: "row",
                alignItems: "center",
                width: dimensions?.width,
                ...style,
            }}
        >
            <StatisticsItem
                source={xpSquare}
                color={theme.colors.accentDark}
                title={plr("XP gagné", student?.xp)}
                count={student?.xp}
                onPress={
                    hasRole(props.user, "student")
                        ? () => nav.push("ranking")
                        : null
                }
            />

            <StatisticsItem
                source={ranking}
                color={theme.colors.errorDark}
                title="classement actuel"
                count={student?.rank}
                onPress={
                    hasRole(props.user, "student")
                        ? () => nav.push("ranking")
                        : null
                }
            />

            <StatisticsItem
                source={treesImage}
                color={theme.colors.petalDarker}
                title="arbres plantés"
                count={countTreesPurchases}
                onPress={
                    hasRole(props.user, "student")
                        ? () => nav.push("petals")
                        : null
                }
            />

            <StatisticsItem
                source={mealsImage}
                color={theme.colors.petalDarker}
                title="repas offerts"
                count={countMealsPurchases}
                onPress={
                    hasRole(props.user, "student")
                        ? () => nav.push("petals")
                        : null
                }
            />
        </View>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.data.currentUser?.object,
        successes: state.data.staticData?.successes,
        gems: state.data.staticData?.gems,
        shopProducts: state.data.staticData?.shop_products,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
}

export default connect(mapStateToProps, mapDispatchToProps)(StatisticsList)
